"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _constant = require("../constant");

var _utilities = _interopRequireDefault(require("../../utilities"));

var _button = _interopRequireDefault(require("./button.proptypes"));

var _constant2 = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/* eslint-disable max-len */
// const ButtonWrapper = styled.div`
//   display: flex;
// `;


var extractMargin = function extractMargin(_ref) {
  var margin = _ref.margin,
      theme = _ref.theme;
  return margin ? "".concat(theme.space[margin[0]], " ").concat(theme.space[margin[1]], " ").concat(theme.space[margin[2]], "  ").concat(theme.space[margin[3]], " ") : "0px";
};

var ButtonContainer = _styledComponents.default.a.withConfig({
  displayName: "Button__ButtonContainer",
  componentId: "sc-7xd2ll-0"
})(["border:1px solid ", ";border-radius:", ";padding-top:", ";padding-bottom:", ";padding-left:", ";padding-right:", ";font-family:", ";font-size:", ";font-weight:", ";color:", ";background-color:", ";text-align:center;text-decoration:none;box-shadow:", ";margin:", ";display:inline-block;", ";", ";&:hover{cursor:pointer;}", ""], function (props) {
  return props.border ? props.theme.colors[props.border] : props.theme.colors.greyLight;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius.normal;
}, function (_ref3) {
  var theme = _ref3.theme,
      paddingTop = _ref3.paddingTop;
  return paddingTop || theme.space.XSmall;
}, function (_ref4) {
  var theme = _ref4.theme,
      paddingBottom = _ref4.paddingBottom;
  return paddingBottom || theme.space.XSmall;
}, function (_ref5) {
  var theme = _ref5.theme,
      paddingLeft = _ref5.paddingLeft;
  return paddingLeft || theme.space.semi;
}, function (_ref6) {
  var theme = _ref6.theme,
      paddingRight = _ref6.paddingRight;
  return paddingRight || theme.space.semi;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontFamily.default;
}, function (_ref8) {
  var theme = _ref8.theme,
      size = _ref8.size;
  return theme.fontSize[size];
}, function (_ref9) {
  var theme = _ref9.theme,
      fontWeight = _ref9.fontWeight;
  return fontWeight ? theme.fontWeight[fontWeight] : theme.fontWeight.normal;
}, function (_ref10) {
  var theme = _ref10.theme,
      color = _ref10.color;
  return color ? theme.colors[color] : theme.colors.primary;
}, function (_ref11) {
  var theme = _ref11.theme,
      backgroundColor = _ref11.backgroundColor;
  return backgroundColor ? theme.colors[backgroundColor] : theme.colors.default;
}, function (_ref12) {
  var boxShadow = _ref12.boxShadow;
  return boxShadow ? '0px 1px 1px rgba(0, 0, 0, 0.2)' : 'none';
}, function (props) {
  return extractMargin(props);
}, function (_ref13) {
  var width = _ref13.width;
  return width && "width: ".concat(width, "\n ");
}, function (_ref14) {
  var hoverBackgroundColor = _ref14.hoverBackgroundColor,
      hoverColor = _ref14.hoverColor;
  return hoverBackgroundColor && hoverColor && (0, _styledComponents.css)(["&:hover{color:", ";background-color:", ";}"], function (_ref15) {
    var theme = _ref15.theme;
    return hoverColor ? theme.colors[hoverColor] : theme.colors.default;
  }, function (_ref16) {
    var theme = _ref16.theme;
    return hoverBackgroundColor ? theme.colors[hoverBackgroundColor] : theme.colors.primary;
  });
}, function (_ref17) {
  var theme = _ref17.theme,
      disabled = _ref17.disabled,
      defaultDisabledFeatures = _ref17.defaultDisabledFeatures;
  return disabled && (defaultDisabledFeatures ? (0, _styledComponents.css)(["background-color:", ";cursor:not-allowed;color:", ";"], theme.colors.greyLighter, theme.colors.greyMedium) : (0, _styledComponents.css)(["pointer-events:none;background-color:", ";color:", ";"], theme.colors.greyLighter, theme.colors.greyMedium));
});

var Button = function Button(props) {
  var accessible = props.accessible,
      theme = props.theme,
      target = props.target,
      href = props.href,
      size = props.size,
      color = props.color,
      hoverColor = props.hoverColor,
      border = props.border,
      backgroundColor = props.backgroundColor,
      hoverBackgroundColor = props.hoverBackgroundColor,
      width = props.width,
      margin = props.margin,
      customProperties = props.customProperties,
      handleClick = props.handleClick,
      children = props.children,
      type = props.type,
      className = props.className,
      queryParams = props.queryParams,
      buttonType = props.buttonType,
      cardIndex = props.cardIndex,
      boxShadow = props.boxShadow,
      disabled = props.disabled,
      defaultDisabledFeatures = props.defaultDisabledFeatures,
      updateGtmId = props.updateGtmId,
      buttonName = props.buttonName,
      paddingLeft = props.paddingLeft,
      paddingRight = props.paddingRight,
      fontWeight = props.fontWeight;
  var tabIndex = !accessible ? '-1' : '0';

  var detectQueryString = function detectQueryString(url) {
    var pattern = new RegExp(/\?.+=.*/g);
    return pattern.test(url);
  };

  var createParams = function createParams() {
    if (!queryParams || JSON.stringify(queryParams) === JSON.stringify({})) {
      return;
    }

    var qParams = ''; // eslint-disable-next-line no-restricted-syntax

    for (var key in queryParams) {
      // eslint-disable-next-line no-prototype-builtins
      if (queryParams.hasOwnProperty(key)) {
        qParams += "".concat(key, "=").concat(queryParams[key], "&");
      }
    }

    qParams = qParams.substring(0, qParams.length - 1); // eslint-disable-next-line consistent-return

    return qParams;
  };

  var formatHref = function formatHref() {
    if (!queryParams || JSON.stringify(queryParams) === JSON.stringify({})) {
      return href;
    }

    var formattedHref = "".concat(href);

    if (!detectQueryString(formattedHref)) {
      formattedHref += '?';
    } else {
      formattedHref += '&';
    }

    formattedHref += createParams();
    return formattedHref;
  };

  var formattedHref = formatHref();

  var handleOnClick = function handleOnClick(e) {
    if (updateGtmId && buttonName) {
      updateGtmId(buttonName);
    }
    /* e.stopPropagation();  causes error with accessibility keyDown->Enter */


    if (buttonType === 'link') {
      return;
    } // eslint-disable-next-line consistent-return


    return handleClick && handleClick(e, cardIndex);
  };

  var handleOnKeyPress = function handleOnKeyPress(e) {
    if (e.key === 'Enter' || e.key === 'NumpadEnter') {
      handleClick();
    }
  };

  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var getMain = function getMain() {
    return buttonType === _constant2.BUTTON_TYPE.link ? /*#__PURE__*/_react.default.createElement(ButtonContainer, (0, _extends2.default)({
      target: _constant2.LINK_TARGET[target].code,
      href: type === _constant2.REDIRECTION_TYPE.secured ? '#' : formattedHref,
      tabIndex: tabIndex,
      color: color,
      className: className,
      border: border,
      hoverColor: hoverColor,
      backgroundColor: backgroundColor,
      hoverBackgroundColor: hoverBackgroundColor,
      theme: themeContext,
      width: width,
      margin: margin,
      size: size,
      boxShadow: boxShadow,
      disabled: disabled,
      defaultDisabledFeatures: defaultDisabledFeatures,
      paddingLeft: paddingLeft,
      paddingRight: paddingRight,
      fontWeight: fontWeight
    }, customProperties), children) : /*#__PURE__*/_react.default.createElement(ButtonContainer, (0, _extends2.default)({
      color: color,
      tabIndex: tabIndex,
      onClick: handleOnClick,
      onKeyDown: function onKeyDown(e) {
        return _utilities.default.keyDownHandler(e, handleOnClick, _constant.KEY_CODE.ENTER);
      },
      hoverColor: hoverColor,
      size: size,
      border: border,
      backgroundColor: backgroundColor,
      hoverBackgroundColor: hoverBackgroundColor,
      theme: themeContext,
      margin: margin,
      className: className,
      width: width,
      boxShadow: boxShadow,
      disabled: disabled,
      defaultDisabledFeatures: defaultDisabledFeatures,
      onKeyPress: handleOnKeyPress,
      paddingLeft: paddingLeft,
      paddingRight: paddingRight,
      fontWeight: fontWeight
    }, customProperties), children);
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

Button.propTypes = _button.default.PropTypes;
Button.defaultProps = _button.default.DefaultProps;
var _default = Button;
exports.default = _default;